import * as React from 'react'

import { Box, Button, SearchField, Table, Text } from '@factorialco/deprecated-design-system'
import { ShiftManagementTemplateFragment } from 'generated/resources/graphql'
import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import { Controls, InfiniteLoader } from 'modules/core/hooks/usePaginatedQuery'
import i18n from 'modules/core/lib/i18n'

import { trackAddTemplateShiftManagementStart } from 'modules/shift_management/lib/trackEvents'

import AddShiftTemplate from './Content/AddShiftTemplate'
import ShiftTemplateTable from './Content/ShiftTemplates/Table'

interface Props {
  shiftTemplates: ShiftManagementTemplateFragment[]
  controls: Controls
  search: string
  loading: boolean
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const ShiftTemplatesSettings = ({ shiftTemplates, controls, search, onSearch, loading }: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  const onClick = () => {
    if (!isModalOpen) {
      trackAddTemplateShiftManagementStart()
    }

    setIsModalOpen(!isModalOpen)
  }

  const onClose = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <Box justifyContent="spaceBetween" flexDirection="row" width="full" paddingBottom="s16">
        <Box flexDirection="row" gap="s16" flexGrow>
          <Text.Header2>
            {i18n.t('shift_management.rotating_shifts.section_sub_title')}
          </Text.Header2>

          <Box>
            <SearchField
              placeholder={i18n.t('shift_management.rotating_shifts.search_by_name')}
              onSearch={onSearch}
              search={search}
              variant="regular"
            />
          </Box>
        </Box>

        <Button type="secondary" onClick={onClick} iconName="add">
          {i18n.t('shift_management.rotating_shifts.add_rotating_shifts')}
        </Button>
      </Box>

      {isEmpty(shiftTemplates) ? (
        <Table>
          <Table.Head>
            <Table.Row>
              <Table.HeadCell></Table.HeadCell>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            <Table.Blank
              colSpan={2}
              text={i18n.t('shift_management.rotating_shifts.empty_rotating_shifts')}
              ctaButtonText={i18n.t('shift_management.rotating_shifts.add_rotating_shifts')}
              ctaButtonOnClick={onClick}
            />
          </Table.Body>
        </Table>
      ) : (
        <Box
          data-scroll-container
          width="full"
          overflowY="auto"
          style={{ maxHeight: 'calc(100vh - 415px)' }}
        >
          {!loading && (
            <InfiniteLoader controls={controls}>
              {shiftTemplates.map((template) => (
                <ShiftTemplateTable shiftTemplate={template} key={template.id} />
              ))}
            </InfiniteLoader>
          )}
        </Box>
      )}

      {isModalOpen && <AddShiftTemplate onClose={onClose} />}
    </>
  )
}

export default observer(ShiftTemplatesSettings)
